import { useContext } from 'react';
import { DatabasesContext } from '../context';

export function useDatabases() {
  const context = useContext(DatabasesContext);
  return { ...context };
}

export default useDatabases;